var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStepIcon4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 59,
    viewBox: "0 0 86 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "desktop/error"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    opacity: 0.6,
    d: "M77.7111 58.0003C72.9633 58.0003 8.77482 57.8514 8.77482 57.8431C8.74822 57.7762 0.626426 47.0667 10.8535 35.8699C15.921 30.322 6.19987 23.1344 10.8535 16.963C18.825 6.39171 26.7123 12.3453 33.2828 9.37214C34.4439 8.8472 35.6088 8.00274 36.775 6.7064C37.4315 5.97741 38.1507 5.3401 38.9209 4.78965C39.0392 4.70486 39.1584 4.62214 39.2788 4.54183C39.7399 4.23403 40.2182 3.95588 40.7106 3.70564C41.0416 3.53779 41.3783 3.38268 41.7218 3.23998C42.2664 3.01353 42.8261 2.8181 43.3977 2.653C44.2096 2.41827 45.0451 2.24352 45.8974 2.1253C46.269 2.07325 46.6439 2.03258 47.0216 2.0019C54.3636 1.40802 62.6257 4.74795 66.8897 9.62961C67.748 10.6126 71.6516 15.6987 68.5746 22.6898C66.6318 27.1037 74.7709 31.3191 77.663 36.3597C85.0162 49.1744 77.7777 57.8331 77.7108 58.0003H77.7111Z",
    fill: "#F4E4FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M14.7043 57.8763H19.7452C20.0151 57.6531 19.5581 57.1465 19.0808 57.1127C18.8734 57.0972 18.611 57.1397 18.3113 57.2011C18.2418 56.3041 17.8459 52.2722 16.353 52.4345C14.6745 52.6161 16.353 54.2099 16.8273 55.1537C17.1791 55.8526 17.5497 56.8552 17.7189 57.3286C17.5825 57.3571 17.4415 57.3856 17.2972 57.4111C17.0749 56.7461 16.2468 54.5094 15.194 54.6398C13.9581 54.7924 14.4547 55.6893 15.3309 56.2216C15.9734 56.6133 16.7628 57.1697 17.1379 57.4382C16.8204 57.4889 16.4884 57.5227 16.1521 57.515C15.2887 57.4952 14.867 57.7425 14.7038 57.8758L14.7043 57.8763Z",
    fill: "#3DC699"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M74.8726 57.6929H70.961C70.7512 57.5165 71.1061 57.1161 71.4766 57.089C71.6374 57.0771 71.841 57.1104 72.0735 57.1589C72.1274 56.4498 72.4345 53.2622 73.5931 53.3905C74.8958 53.534 73.5931 54.7943 73.225 55.5404C72.9522 56.0929 72.6646 56.8855 72.5328 57.2596C72.6385 57.2822 72.7479 57.3044 72.8598 57.3249C73.0327 56.7992 73.6747 55.0307 74.4917 55.1339C75.4508 55.2547 75.0654 55.9634 74.3856 56.3844C73.8869 56.6939 73.2743 57.1338 72.9833 57.3463C73.23 57.3862 73.4874 57.4133 73.7481 57.4072C74.4183 57.3915 74.7449 57.5872 74.8718 57.6925L74.8726 57.6929Z",
    fill: "#8FDEC4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M1.25288 58H84.7463C84.8039 58 84.8507 58.0561 84.8507 58.1251V58.1971C84.8507 58.2661 84.8039 58.3222 84.7463 58.3222H1.25288C1.19526 58.3222 1.14844 58.2661 1.14844 58.1971V58.1251C1.14844 58.0561 1.19526 58 1.25288 58Z",
    fill: "#233862"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M41.0331 31.8786L38.9702 56.2065C38.9702 56.2065 38.7542 57.681 39.8601 57.6839C41.6785 57.688 48.912 57.6839 48.912 57.6839C48.912 57.6839 47.5433 57.3768 47.5599 56.6862C47.5793 55.8723 49.971 31.6484 49.971 31.6484L41.0331 31.8786Z",
    fill: "#3A6EEC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M49.5922 57.2528C49.2345 57.254 42.2319 57.2655 40.4607 57.2429C39.6889 57.2334 39.5534 56.5622 39.5472 56.128C39.5438 55.92 39.5708 55.7659 39.5708 55.7659L39.6243 55.1336L39.761 53.5222L39.8817 52.0982L40.0371 50.2685L40.1677 48.7241L41.6338 31.4372L50.5716 31.207C50.5716 31.207 49.5644 41.3447 48.8519 48.7236C48.7723 49.5458 48.6968 50.3343 48.6268 51.0701C48.604 51.3052 48.5824 51.5346 48.5609 51.7582C48.495 52.4563 48.4345 53.0976 48.3818 53.6636C48.3541 53.9621 48.3284 54.2391 48.3056 54.4932C48.2148 55.4884 48.1613 56.1239 48.1605 56.2448C48.1605 56.3151 48.1663 56.3809 48.1779 56.4417C48.3246 57.217 49.4579 57.2519 49.5922 57.2519V57.2528Z",
    fill: "#B7CCFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M19.3281 18.6406L24.3535 38.6599L25.0416 41.4014L27.3819 50.7256H70.8651L62.2385 18.6406H19.3281Z",
    fill: "#E7EDFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M19.3292 18.6406L18.6328 18.8708L26.4573 51.4219L27.3833 50.7256L19.3292 18.6406Z",
    fill: "#5B86EF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M26.457 51.4229H69.6725L70.8658 50.7266H27.383L26.457 51.4229Z",
    fill: "#5B86EF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M41.6352 57.6953H50.9922V57.2542H41.6352V57.6953Z",
    fill: "#3A6EEC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M48.6136 51.4219L48.5651 51.759L39.7656 53.5221L39.8862 52.0981L39.9439 51.4219H48.6136Z",
    fill: "#5B86EF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    opacity: 0.4,
    d: "M49.5919 57.251C49.2342 57.2522 42.2316 57.2637 40.4604 57.2411C39.6886 57.2316 39.5531 56.5603 39.5469 56.1262L48.3049 54.4922C48.2141 55.4874 48.1606 56.1229 48.1598 56.2438C48.1598 56.3141 48.1656 56.3799 48.1772 56.4407C48.3239 57.216 49.4572 57.251 49.5915 57.251H49.5919Z",
    fill: "#5B86EF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M19.3281 18.6406H62.2385L69.2004 44.427H25.801L19.3281 18.6406Z",
    fill: "#E7EDFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M67.1807 43.3104H27.0036L25.5677 37.6383L25.0123 35.4435L24.786 34.5486L23.3104 28.7195L23.2337 28.4161L22.454 25.3346L22.105 23.9563L21.8074 22.7802L21.1094 20.0234H60.707L61.4735 22.7802L61.8005 23.9563L62.1835 25.3346L64.7082 34.4175V34.4179L64.9221 35.1874L65.0216 35.5447L66.765 41.8149L67.1807 43.3104Z",
    fill: "#B7CCFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M61.4735 22.7767H21.8074L21.1094 20.0195H60.7075L61.4735 22.7767Z",
    fill: "#5B86EF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M22.745 21.2664C22.6974 21.076 22.8139 20.9219 23.0058 20.9219C23.1977 20.9219 23.3921 21.076 23.4398 21.2664C23.4874 21.4567 23.3709 21.6108 23.179 21.6108C22.9871 21.6108 22.7927 21.4567 22.745 21.2664Z",
    fill: "#FBFCFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M23.9013 21.2664C23.8536 21.076 23.9701 20.9219 24.162 20.9219C24.3539 20.9219 24.5483 21.076 24.596 21.2664C24.6437 21.4567 24.5272 21.6108 24.3353 21.6108C24.1434 21.6108 23.949 21.4567 23.9013 21.2664Z",
    fill: "#FBFCFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M25.1435 21.2664C25.0958 21.076 25.2123 20.9219 25.4042 20.9219C25.5961 20.9219 25.7905 21.076 25.8382 21.2664C25.8859 21.4567 25.7694 21.6108 25.5775 21.6108C25.3856 21.6108 25.1912 21.4567 25.1435 21.2664Z",
    fill: "#FBFCFF"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 37537"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 7372",
    x: 27.6641,
    y: 10.2539,
    width: 35.7754,
    height: 33.8923,
    rx: 8,
    fill: "#FF8165"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 1",
    d: "M32.8815 42.9666L39.4442 43.0396L31.6861 49.3761L32.8815 42.9666Z",
    fill: "#FF8165"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M47.1712 19.7775C47.1961 20.0705 47.1665 20.3458 47.0814 20.6034C46.9965 20.8607 46.8651 21.0885 46.6869 21.2867C46.5087 21.4846 46.288 21.6463 46.0244 21.771C45.7611 21.8955 45.4586 21.9724 45.1172 22.0008C44.7761 22.0291 44.4624 22.0035 44.1771 21.9246C43.8916 21.8455 43.6441 21.7227 43.435 21.5569C43.2256 21.3909 43.0575 21.1879 42.9302 20.9484C42.8029 20.7084 42.7268 20.4422 42.7016 20.149C42.6767 19.8561 42.7068 19.5829 42.7919 19.3299C42.8771 19.0767 43.0088 18.8513 43.187 18.6531C43.3652 18.455 43.5883 18.2932 43.8563 18.1683C44.1243 18.0433 44.429 17.9663 44.7704 17.938C45.1117 17.9096 45.423 17.9353 45.7036 18.0146C45.9844 18.094 46.2294 18.2168 46.4389 18.3829C46.648 18.5486 46.8164 18.7492 46.9431 18.9849C47.0701 19.2203 47.146 19.4846 47.1712 19.7775ZM43.187 23.8911L46.9431 23.8911L47.1723 35.1211L43.435 35.1211L43.187 23.8911Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector 1",
    d: "M60.1953 8.8431V2.57812M62.9036 10.3115L69.2793 3.54479",
    stroke: "#A020FF",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 2",
    d: "M64.7344 12.8906H70.5741",
    stroke: "#A020FF",
    strokeLinecap: "round"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStepIcon4);
export default __webpack_public_path__ + "static/media/StepIcon4.bd3d1e2144eefaab6f98a92599175b8a.svg";
export { ForwardRef as ReactComponent };